// ----------------------------------------------------------------------------
// Section: Stores
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import 'snippets/_containers/css-grid/css-grid';
import 'snippets/icon/icon';

// Styles
import './_stores.scss';

function normalizeValue(value) {
  return (value || '').trim();
}

function getData(el, key) {
  return normalizeValue(el.getAttribute('data-' + key));
}

function buildOptions(select, items, allLabel) {
  select.innerHTML = `<option value="All">${allLabel}</option>`;
  items.forEach(item => {
    const opt = document.createElement('option');
    opt.value = item;
    opt.textContent = item;
    select.appendChild(opt);
  });
}

function getUniqueValues(blocks, key, filterKey, filterValue) {
  const values = new Set();
  blocks.forEach(block => {
    if (!filterKey || filterValue === 'All' || getData(block, filterKey) === filterValue) {
      const value = getData(block, key);
      if (value) values.add(value);
    }
  });
  return Array.from(values).sort((a, b) => a.localeCompare(b));
}

function initStores(filters) {
  const storesWrap = filters.closest('[data-stores]');
  if (storesWrap) {
    storesWrap.classList.add('stores--loading');
  } else {
    filters.classList.add('stores__filters--loading');
  }
  const countrySelect = filters.querySelector('[data-filter="country"]');
  const provinceSelect = filters.querySelector('[data-filter="province"]');
  const storeBlocks = Array.from(document.querySelectorAll('.store-block'));

  if (!countrySelect || !provinceSelect || storeBlocks.length === 0) return;

  function updateProvinceOptions() {
    const provinces = getUniqueValues(storeBlocks, 'province', 'country', countrySelect.value);
    if (provinces.length === 0) return;
    buildOptions(provinceSelect, provinces, 'All');
  }

  function updateCountryOptions() {
    const countries = getUniqueValues(storeBlocks, 'country');
    if (countries.length === 0) return;
    buildOptions(countrySelect, countries, 'All Countries');
  }

  function filterBlocks() {
    const country = countrySelect.value;
    const province = provinceSelect.value;
    storeBlocks.forEach(block => {
      const matchCountry = (country === 'All' || getData(block, 'country') === country);
      const matchProvince = (province === 'All' || getData(block, 'province') === province);
      block.style.display = (matchCountry && matchProvince) ? '' : 'none';
    });
  }

  function setCountryIfAvailable(preferredValues) {
    const options = Array.from(countrySelect.options).map(option => option.value);
    const match = preferredValues.find(value => options.includes(value));
    countrySelect.value = match || 'All';
    countrySelect.dispatchEvent(new Event('change'));
  }

  updateCountryOptions();

  countrySelect.addEventListener('change', function() {
    updateProvinceOptions();
    filterBlocks();
  });
  provinceSelect.addEventListener('change', filterBlocks);

  const shopDomain = window.Shopify && Shopify.shop;
  if (shopDomain && shopDomain.includes('dish-du-er')) {
    setCountryIfAvailable(['Canada', 'CA']);
  } else if (shopDomain && shopDomain.includes('dishandduer')) {
    setCountryIfAvailable(['United States', 'US', 'USA']);
  } else {
    setCountryIfAvailable(['United States', 'US', 'USA', 'Canada', 'CA']);
  }

  requestAnimationFrame(() => {
    if (storesWrap) {
      storesWrap.classList.remove('stores--loading');
      storesWrap.classList.add('stores--ready');
      storesWrap.style.opacity = '';
      const storesId = storesWrap.getAttribute('data-stores-id');
      const loadingTarget = storesId ? document.getElementById(`stores-loading-${storesId}`) : null;
      if (loadingTarget) {
        loadingTarget.style.display = 'none';
      }
      const loading = storesWrap.querySelector('.stores__loading');
      if (loading) {
        loading.style.display = 'none';
        loading.remove();
      }
      setTimeout(() => {
        const lingering = storesWrap.querySelector('.stores__loading');
        if (lingering) lingering.style.display = 'none';
      }, 0);
    } else {
      filters.classList.remove('stores__filters--loading');
    }
  });
}

function initAllStores() {
  const filters = document.querySelectorAll('.stores__filters');
  filters.forEach(initStores);
}

$(document).ready(function() {
  initAllStores();
  setTimeout(initAllStores, 500);
});

document.addEventListener('shopify:section:load', function(event) {
  initAllStores();
});
